import { useState } from "react";
import { Table, Button, Typography, Tag } from "antd";
import { useQuery } from "@apollo/client";
import type { ColumnsType } from "antd/es/table";
import { GET_TICKETS } from "./requests";
import moment from "moment-timezone";
import { Container } from "./elements";
import TicketDetailDrawer from "./components/modals/history-modal";
import TableTitle from "./components/table-title";
import EmailsNotificationsDrawer from "./components/modals/emails-modal";
import { useUser } from "../../providers/user";

const { Text } = Typography;

export default function Tickets() {
  const { user } = useUser();
  const [visible, setVisible] = useState(false);
  const [selectedTicketHistory, setSelectedTicketHistory] = useState(null);
  const [userSupport, setUserSupport] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [ticektId, setTicketId] = useState(null);
  const [pageConfig, setPageConfig] = useState({ page: 1,
    pageSize: 10 });
  const [showEmailsModal, setShowEmailsModal] = useState(false);

  const { loading, data, refetch } = useQuery(GET_TICKETS, {
    variables: {
      params: pageConfig,
    },
  });

  const columns: ColumnsType<any> = [
    {
      title: "Referencia",
      key: "order",
      render: (record) => {
        const reference = record?.order?.reference;
        if(reference){
          return reference;
        } else {
          return <Tag color="yellow">N/A</Tag>;
        }
      },
    },
    {
      title: "Cliente",
      key: "client",
      render: (record) => <p>{record.client.user?.firstName} {record.client.user?.lastName}</p>,
    },
    {
      title: "Usuario Asignado",
      key: "user",
      render: (record) => {
        const support = record.user;
        if(support?.firstName && support?.lastName){
          return `${support?.firstName} ${support?.lastName}`;
        } else {
          return <Tag color="yellow">N/D</Tag>;
        }
      },
    },
    {
      title: "Sucursal",
      key: "location",
      render: (record) => {
        const locationName = record?.location?.name;
        if(locationName){
          return locationName;
        } else {
          return <Tag color="yellow">N/A</Tag>;
        }
      },
    },
    {
      title: "Fecha",
      key: "createdAt",
      render: (row) => moment(row?.createdAt).format("DD/MM/YYYY"),
    },
    {
      title: "Acciones",
      key: "actions",
      render: (row) => (
        <Button
          type="primary"
          onClick={() => {
            setVisible(true);
            setSelectedTicketHistory(row.history);
            setUserSupport(row.user);
            setSelectedClient(row.client);
            setTicketId(row.id);
          }}
        >
          Ver Historial
        </Button>
      ),
    },
  ];

  return (
    <Container style={{ overflow: "scroll" }}>
      <Table
        title={() => (
          <TableTitle
            setShowEmailsModal={setShowEmailsModal}
          />
        )}
        loading={loading}
        columns={columns}
        dataSource={data?.tickets?.results ?? []}
        rowKey="id"
        pagination={{
          current: Number(pageConfig.page),
          defaultCurrent: pageConfig.page,
          pageSize: Number(pageConfig.pageSize),
          defaultPageSize: pageConfig.pageSize,
          total: data?.tickets?.info?.count,
          showTotal: (total) => (
            <Text disabled>{`${total} resultados`}</Text>
          ),
          onChange: (page, pageSize) => {
            setPageConfig({
              page,
              pageSize,
            });
          },
          showSizeChanger: true,
        }}
      />
      <TicketDetailDrawer
        showModal={visible}
        setShowModal={setVisible}
        history={selectedTicketHistory}
        userSupport={userSupport}
        client={selectedClient}
        refetch={refetch}
        ticketId={ticektId}
      />
      <EmailsNotificationsDrawer
        open={showEmailsModal}
        setOpen={setShowEmailsModal}
        user={user}
      />

    </Container>
  );
};


